class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.timerFrame = null;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );


      // const dealsItems = this.notification.querySelectorAll('.deals-grid__item');
      // let dealsIndex = 0;
      // if (dealsItems) {
      //   setTimeout(function() {
      //     dealsItems.forEach(function(deal) {
      //       setTimeout(function() {
      //         if (deal?.dataset?.filled == 'half' || deal?.dataset?.filled == 'full') {
      //           deal.classList.add('js-deal-animate');
      //         }
      //       },(300*dealsIndex));
      //       dealsIndex++;
      //     });
      //   },300);
      // }

    const timerProgress = this.notification.querySelector('.timer-progress');
    let duration = 2500;
    let start = null;

    if (timerProgress) {
      timerProgress.style.strokeDashoffset = 100;

      const animate = (timestamp) => {
        if (!start) start = timestamp;
        const elapsed = timestamp - start;
        const percent = Math.min(elapsed / duration, 1);
        timerProgress.style.strokeDashoffset = 100 - percent * 100;

        if (elapsed < duration) {
          this.timerFrame = requestAnimationFrame(animate);
        } else {
          this.close();
        }
      };

      this.timerFrame = requestAnimationFrame(animate);
    }

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);


    if (this.timerFrame) {
      cancelAnimationFrame(this.timerFrame);
      this.timerFrame = null;
    }

    const timerProgress = this.notification.querySelector('.timer-progress');
    if (timerProgress) {
      timerProgress.style.strokeDashoffset = 100;
    }

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }


  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
